import { render, staticRenderFns } from "./ChannelManagedHotelsWithNoRecentUpdates.vue?vue&type=template&id=20336f8f&"
import script from "./ChannelManagedHotelsWithNoRecentUpdates.vue?vue&type=script&lang=js&"
export * from "./ChannelManagedHotelsWithNoRecentUpdates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20336f8f')) {
      api.createRecord('20336f8f', component.options)
    } else {
      api.reload('20336f8f', component.options)
    }
    module.hot.accept("./ChannelManagedHotelsWithNoRecentUpdates.vue?vue&type=template&id=20336f8f&", function () {
      api.rerender('20336f8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pages/ChannelManagers/ChannelManagedHotelsWithNoRecentUpdates.vue"
export default component.exports